import React from 'react';
import { View, TouchableOpacity, Text,} from 'react-native';
import styles from "./style";

const ButtonsActionTransaction = ({ buttons, navigation }) => {
  return (
    <View style={styles.container}>
      {buttons.map((button, index) => (
        <TouchableOpacity
          key={index}
          onPress={() => navigation.navigate(button.route)}
          style={styles.listItem}
        >
          <View style={styles.itemTextSection}>
            <Text style={styles.textBold}>{button.text}</Text>
          </View>
        </TouchableOpacity>
      ))}
    </View>
  );
};

export default ButtonsActionTransaction;
